import request from './request'

// 1. 企业认证输入
export const getCertification = (data) =>
	request({
		url: '/api/login/business/verify/submit',
		method: 'post',
		data
	})

// 2. 企业认证（社保缴费记录）
export const getSocial = (data) =>
	request({
		url: '/api/login/business/social/bind/relation',
		method: 'post',
		data
	})